import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Agent } from "api/agent";

export const useGetAllEquipmentTypes = (
  { pageNumber = -1, pageSize = -1, assetCategoryId } = {
    pageNumber: -1,
    pageSize: -1,
    assetCategoryId: null,
  },
  options = {}
) => {
  return useQuery({
    queryKey: ["getAllEquipmentTypes", pageNumber, pageSize, assetCategoryId],
    queryFn: () =>
      Agent.equipmentType.getAll({
        pageNumber: pageNumber,
        pageSize: pageSize,
        assetCategoryId: assetCategoryId,
      }),
    staleTime: 1000 * 60 * 60,
    ...options,
  });
};

export const useGetEquipmentTypeById = (id, options = {}) => {
  return useQuery({
    queryKey: ["getEquipmentTypeById", +id],
    queryFn: () => Agent.equipmentType.getById(id),
    staleTime: 1000 * 60 * 10,
    ...options,
  });
};

export const useCreateEquipmentType = ({ config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["createEquipmentType"],
    mutationFn: (body) => Agent.equipmentType.create(body),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["getAllEquipmentTypes"] });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};

export const useUpdateEquipmentType = ({ id, config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["updateEquipmentType"],
    mutationFn: (body) => Agent.equipmentType.update(id, body),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["getAllEquipmentTypes"] });
      queryClient.invalidateQueries({
        queryKey: ["getEquipmentTypeById", +id],
      });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};

export const useDeleteEquipmentType = ({ id, config = {} }) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    mutationKey: ["deleteEquipmentType"],
    mutationFn: () => Agent.equipmentType.delete(id),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["getAllEquipmentTypes"] });
      onSuccess?.(...args);
    },
    ...restConfig,
  });
};
